var map = {
	"./MathBowl/Grade10/2025/premium0/math_quiz.json": 801,
	"./MathBowl/Grade11/2025/premium0/math_quiz.json": 802,
	"./MathBowl/Grade12/2025/premium0/math_quiz.json": 803,
	"./MathBowl/Grade4/2025/premium0/math_quiz.json": 804,
	"./MathBowl/Grade5/2025/premium0/math_quiz.json": 805,
	"./MathBowl/Grade6/2025/premium0/math_quiz.json": 806,
	"./MathBowl/Grade7/2025/premium0/math_quiz.json": 807,
	"./MathBowl/Grade8/2025/premium0/math_quiz.json": 808,
	"./MathBowl/Grade9/2025/premium0/math_quiz.json": 809,
	"./ScienceBowl/Grade7/premium100/Biology.json": 810,
	"./ScienceBowl/Grade7/premium100/Earth and Space.json": 811,
	"./ScienceBowl/Grade7/premium100/EarthScience.json": 812,
	"./ScienceBowl/Grade7/premium100/Energy.json": 813,
	"./ScienceBowl/Grade7/premium100/GeneralScience.json": 814,
	"./ScienceBowl/Grade7/premium100/LifeScience.json": 815,
	"./ScienceBowl/Grade7/premium100/Mathematics.json": 816,
	"./ScienceBowl/Grade7/premium100/PhysicalScience.json": 817,
	"./ScienceBowl/Grade7/premium1000/2007_Energy-Category.json": 818,
	"./ScienceBowl/Grade7/premium1000/2007_Round-10C-MS.json": 819,
	"./ScienceBowl/Grade7/premium1000/2007_Round-11C-MS.json": 820,
	"./ScienceBowl/Grade7/premium1000/2007_Round-12C-MS.json": 821,
	"./ScienceBowl/Grade7/premium1000/2007_Round-13C-MS.json": 822,
	"./ScienceBowl/Grade7/premium1000/2007_Round-14C-MS.json": 823,
	"./ScienceBowl/Grade7/premium1000/2007_Round-15C-MS.json": 824,
	"./ScienceBowl/Grade7/premium1000/2007_Round-1C-MS.json": 825,
	"./ScienceBowl/Grade7/premium1000/2007_Round-2C-MS.json": 826,
	"./ScienceBowl/Grade7/premium1000/2007_Round-4C-MS.json": 827,
	"./ScienceBowl/Grade7/premium1000/2007_Round-5C-MS.json": 828,
	"./ScienceBowl/Grade7/premium1000/2007_Round-6C-MS.json": 829,
	"./ScienceBowl/Grade7/premium1000/2007_Round-7C-MS.json": 830,
	"./ScienceBowl/Grade7/premium1000/2007_Round-8C-MS.json": 831,
	"./ScienceBowl/Grade7/premium1000/2007_Round-9C-MS.json": 832,
	"./ScienceBowl/Grade7/premium1000/2007_Round1.json": 833,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r1.json": 834,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r10.json": 835,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r2.json": 836,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r3.json": 837,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r4.json": 838,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r5.json": 839,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r6.json": 840,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r7.json": 841,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r8.json": 842,
	"./ScienceBowl/Grade7/premium1000/2008_sample_questions_r9.json": 843,
	"./ScienceBowl/Grade7/premium1000/2009_m_round01.json": 844,
	"./ScienceBowl/Grade7/premium1000/2009_m_round02.json": 845,
	"./ScienceBowl/Grade7/premium1000/2009_m_round03.json": 846,
	"./ScienceBowl/Grade7/premium1000/2009_m_round04.json": 847,
	"./ScienceBowl/Grade7/premium1000/2009_m_round05.json": 848,
	"./ScienceBowl/Grade7/premium1000/2009_m_round06.json": 849,
	"./ScienceBowl/Grade7/premium1000/2009_m_round07.json": 850,
	"./ScienceBowl/Grade7/premium1000/2009_m_round08.json": 851,
	"./ScienceBowl/Grade7/premium1000/2009_m_round09.json": 852,
	"./ScienceBowl/Grade7/premium1000/2009_m_round10.json": 853,
	"./ScienceBowl/Grade7/premium1000/2009_m_round11.json": 854,
	"./ScienceBowl/Grade7/premium1000/2009_m_round12.json": 855,
	"./ScienceBowl/Grade7/premium1000/2009_m_round13.json": 856,
	"./ScienceBowl/Grade7/premium1000/2009_m_round14.json": 857,
	"./ScienceBowl/Grade7/premium1000/2009_m_round15.json": 858,
	"./ScienceBowl/Grade7/premium1000/2009_m_round16.json": 859,
	"./ScienceBowl/Grade7/premium1000/2009_m_round17.json": 860,
	"./ScienceBowl/Grade7/premium1000/2009_m_round18.json": 861,
	"./ScienceBowl/Grade7/premium1000/2010_Round1.json": 862,
	"./ScienceBowl/Grade7/premium1000/2010_Round10.json": 863,
	"./ScienceBowl/Grade7/premium1000/2010_Round11.json": 864,
	"./ScienceBowl/Grade7/premium1000/2010_Round12.json": 865,
	"./ScienceBowl/Grade7/premium1000/2010_Round13.json": 866,
	"./ScienceBowl/Grade7/premium1000/2010_Round14.json": 867,
	"./ScienceBowl/Grade7/premium1000/2010_Round15.json": 868,
	"./ScienceBowl/Grade7/premium1000/2010_Round16.json": 869,
	"./ScienceBowl/Grade7/premium1000/2010_Round17.json": 870,
	"./ScienceBowl/Grade7/premium1000/2010_Round2.json": 871,
	"./ScienceBowl/Grade7/premium1000/2010_Round3.json": 872,
	"./ScienceBowl/Grade7/premium1000/2010_Round4.json": 873,
	"./ScienceBowl/Grade7/premium1000/2010_Round5.json": 874,
	"./ScienceBowl/Grade7/premium1000/2010_Round6.json": 875,
	"./ScienceBowl/Grade7/premium1000/2010_Round7.json": 876,
	"./ScienceBowl/Grade7/premium1000/2010_Round8.json": 877,
	"./ScienceBowl/Grade7/premium1000/2010_Round9.json": 878,
	"./ScienceBowl/Grade7/premium1000/2011_Round1.json": 879,
	"./ScienceBowl/Grade7/premium1000/2011_Round10.json": 880,
	"./ScienceBowl/Grade7/premium1000/2011_Round11.json": 881,
	"./ScienceBowl/Grade7/premium1000/2011_Round12.json": 882,
	"./ScienceBowl/Grade7/premium1000/2011_Round13.json": 883,
	"./ScienceBowl/Grade7/premium1000/2011_Round14.json": 884,
	"./ScienceBowl/Grade7/premium1000/2011_Round15.json": 885,
	"./ScienceBowl/Grade7/premium1000/2011_Round2.json": 886,
	"./ScienceBowl/Grade7/premium1000/2011_Round3.json": 887,
	"./ScienceBowl/Grade7/premium1000/2011_Round4.json": 888,
	"./ScienceBowl/Grade7/premium1000/2011_Round5.json": 889,
	"./ScienceBowl/Grade7/premium1000/2011_Round6.json": 890,
	"./ScienceBowl/Grade7/premium1000/2011_Round7.json": 891,
	"./ScienceBowl/Grade7/premium1000/2011_Round8.json": 892,
	"./ScienceBowl/Grade7/premium1000/2011_Round9.json": 893,
	"./ScienceBowl/Grade7/premium1000/2012_MS_Round-1.json": 894,
	"./ScienceBowl/Grade7/premium1000/2012_MS_Round-2.json": 895,
	"./ScienceBowl/Grade7/premium1000/2012_Round10.json": 896,
	"./ScienceBowl/Grade7/premium1000/2012_Round11.json": 897,
	"./ScienceBowl/Grade7/premium1000/2012_Round12.json": 898,
	"./ScienceBowl/Grade7/premium1000/2012_Round13.json": 899,
	"./ScienceBowl/Grade7/premium1000/2012_Round14.json": 900,
	"./ScienceBowl/Grade7/premium1000/2012_Round15.json": 901,
	"./ScienceBowl/Grade7/premium1000/2012_Round16.json": 902,
	"./ScienceBowl/Grade7/premium1000/2012_Round17.json": 903,
	"./ScienceBowl/Grade7/premium1000/2012_Round3.json": 904,
	"./ScienceBowl/Grade7/premium1000/2012_Round4.json": 905,
	"./ScienceBowl/Grade7/premium1000/2012_Round5.json": 906,
	"./ScienceBowl/Grade7/premium1000/2012_Round6.json": 907,
	"./ScienceBowl/Grade7/premium1000/2012_Round7.json": 908,
	"./ScienceBowl/Grade7/premium1000/2012_Round8.json": 909,
	"./ScienceBowl/Grade7/premium1000/2012_Round9.json": 910,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-10.json": 911,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-11.json": 912,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-12.json": 913,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-13.json": 914,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-14.json": 915,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-15.json": 916,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-3.json": 917,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-4.json": 918,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-5.json": 919,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-6.json": 920,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-7.json": 921,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-8.json": 922,
	"./ScienceBowl/Grade7/premium1000/2013_MS_Round-9.json": 923,
	"./ScienceBowl/Grade7/premium1000/2013_Round-1-A.json": 924,
	"./ScienceBowl/Grade7/premium1000/2013_Round-2-A.json": 925,
	"./ScienceBowl/Grade7/premium1000/2014_Round-10-A.json": 926,
	"./ScienceBowl/Grade7/premium1000/2014_Round-11-A.json": 927,
	"./ScienceBowl/Grade7/premium1000/2014_Round-12-A.json": 928,
	"./ScienceBowl/Grade7/premium1000/2014_Round-13-A.json": 929,
	"./ScienceBowl/Grade7/premium1000/2014_Round-14-A.json": 930,
	"./ScienceBowl/Grade7/premium1000/2014_Round-15-A.json": 931,
	"./ScienceBowl/Grade7/premium1000/2014_Round-16-A.json": 932,
	"./ScienceBowl/Grade7/premium1000/2014_Round-17-A.json": 933,
	"./ScienceBowl/Grade7/premium1000/2014_Round-3-A.json": 934,
	"./ScienceBowl/Grade7/premium1000/2014_Round-4-A.json": 935,
	"./ScienceBowl/Grade7/premium1000/2014_Round-5-A.json": 936,
	"./ScienceBowl/Grade7/premium1000/2014_Round-6-A.json": 937,
	"./ScienceBowl/Grade7/premium1000/2014_Round-7-A.json": 938,
	"./ScienceBowl/Grade7/premium1000/2014_Round-8-A.json": 939,
	"./ScienceBowl/Grade7/premium1000/2014_Round-9-A.json": 940,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_1.json": 941,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_10A.json": 942,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_11A.json": 943,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_12A.json": 944,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_13A.json": 945,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_14A.json": 946,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_15A.json": 947,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_16A.json": 948,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_17A.json": 949,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_2.json": 950,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_3A.json": 951,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_4A.json": 952,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_5A.json": 953,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_6A.json": 954,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_7A.json": 955,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_8A.json": 956,
	"./ScienceBowl/Grade7/premium1000/2015_RegionalMS_9A.json": 957,
	"./ScienceBowl/Grade7/premium1000/2016_10A_MS_Reg_2016.json": 958,
	"./ScienceBowl/Grade7/premium1000/2016_11A_MS_Reg_2016.json": 959,
	"./ScienceBowl/Grade7/premium1000/2016_12A_MS_Reg_2016.json": 960,
	"./ScienceBowl/Grade7/premium1000/2016_13A_MS_Reg_2016.json": 961,
	"./ScienceBowl/Grade7/premium1000/2016_14A_MS_Reg_2016.json": 962,
	"./ScienceBowl/Grade7/premium1000/2016_15A_MS_Reg_2016.json": 963,
	"./ScienceBowl/Grade7/premium1000/2016_16A_MS_Reg_2016.json": 964,
	"./ScienceBowl/Grade7/premium1000/2016_17A_MS_Reg_2016.json": 965,
	"./ScienceBowl/Grade7/premium1000/2016_1A_MS_Reg_2016.json": 966,
	"./ScienceBowl/Grade7/premium1000/2016_2A_MS_Reg_2016.json": 967,
	"./ScienceBowl/Grade7/premium1000/2016_3A_MS_Reg_2016.json": 968,
	"./ScienceBowl/Grade7/premium1000/2016_4A_MS_Reg_2016.json": 969,
	"./ScienceBowl/Grade7/premium1000/2016_5A_MS_Reg_2016.json": 970,
	"./ScienceBowl/Grade7/premium1000/2016_6A_MS_Reg_2016.json": 971,
	"./ScienceBowl/Grade7/premium1000/2016_7A_MS_Reg_2016.json": 972,
	"./ScienceBowl/Grade7/premium1000/2016_8A_MS_Reg_2016.json": 973,
	"./ScienceBowl/Grade7/premium1000/2016_9A_MS_Reg_2016.json": 974,
	"./ScienceBowl/Grade7/premium1000/2016_MS_1.json": 975,
	"./ScienceBowl/Grade7/premium1000/2016_MS_2.json": 976,
	"./ScienceBowl/Grade7/premium1000/2017_MSRound-1.json": 977,
	"./ScienceBowl/Grade7/premium1000/2017_MSRound-2.json": 978,
	"./ScienceBowl/Grade7/premium1000/2017_MS_10A.json": 979,
	"./ScienceBowl/Grade7/premium1000/2017_MS_11A.json": 980,
	"./ScienceBowl/Grade7/premium1000/2017_MS_12A.json": 981,
	"./ScienceBowl/Grade7/premium1000/2017_MS_13A.json": 982,
	"./ScienceBowl/Grade7/premium1000/2017_MS_14A.json": 983,
	"./ScienceBowl/Grade7/premium1000/2017_MS_15A.json": 984,
	"./ScienceBowl/Grade7/premium1000/2017_MS_16A.json": 985,
	"./ScienceBowl/Grade7/premium1000/2017_MS_17A.json": 986,
	"./ScienceBowl/Grade7/premium1000/2017_MS_3A.json": 987,
	"./ScienceBowl/Grade7/premium1000/2017_MS_4A.json": 988,
	"./ScienceBowl/Grade7/premium1000/2017_MS_5A.json": 989,
	"./ScienceBowl/Grade7/premium1000/2017_MS_6A.json": 990,
	"./ScienceBowl/Grade7/premium1000/2017_MS_7A.json": 991,
	"./ScienceBowl/Grade7/premium1000/2017_MS_8A.json": 992,
	"./ScienceBowl/Grade7/premium1000/2017_MS_9A.json": 993,
	"./ScienceBowl/Grade7/premium1000/2018_2019-NSB-MSR-Round-1A.json": 994,
	"./ScienceBowl/Grade7/premium1000/2018_2019-NSB-MSR-Round-2A.json": 995,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-10.json": 996,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-11.json": 997,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-12.json": 998,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-13.json": 999,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-14.json": 1000,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-15.json": 1001,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-16.json": 1002,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-17.json": 1003,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-3.json": 1004,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-4.json": 1005,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-5.json": 1006,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-6.json": 1007,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-7.json": 1008,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-8.json": 1009,
	"./ScienceBowl/Grade7/premium1000/2018_MSRound-9.json": 1010,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-10A.json": 1011,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-11A.json": 1012,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-12A.json": 1013,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-13A.json": 1014,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-14A.json": 1015,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-15A.json": 1016,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-16A.json": 1017,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-17A.json": 1018,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-1A.json": 1019,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-2A.json": 1020,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-3A.json": 1021,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-4A.json": 1022,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-5A.json": 1023,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-6A.json": 1024,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-7A.json": 1025,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-8A.json": 1026,
	"./ScienceBowl/Grade7/premium1000/2019-NSB-MSR-Round-9A.json": 1027,
	"./ScienceBowl/Grade7/premium1000/2019_de1_for_web.json": 1028,
	"./ScienceBowl/Grade7/premium1000/2019_de3_for_web.json": 1029,
	"./ScienceBowl/Grade7/premium1000/2019_rr2_for_web.json": 1030,
	"./ScienceBowl/Grade7/premium1000/2019_rr5_for_web.json": 1031,
	"./SpellBowl/Grade1/2023/premium300/Elementary Word List 2023.json": 296,
	"./SpellBowl/Grade1/2024/premium300/AI Generated Complex Elementary Word List 2024.json": 297,
	"./SpellBowl/Grade1/2024/premium300/Elementary Word List 2024 with hyphens and spaces.json": 298,
	"./SpellBowl/Grade1/2024/premium300/Elementary Word List 2024 with hyphens.json": 299,
	"./SpellBowl/Grade1/2024/premium300/Elementary Word List 2024 with spaces.json": 300,
	"./SpellBowl/Grade1/2024/premium300/Elementary Word List 2024 with upper cases.json": 301,
	"./SpellBowl/Grade1/2024/premium300/Elementary Word List 2024.json": 302,
	"./SpellBowl/Grade10/2023/premium300/Senior Word List 2023.json": 303,
	"./SpellBowl/Grade10/2024/premium300/AI Generated Complex Senior Word List 2024.json": 304,
	"./SpellBowl/Grade10/2024/premium300/Senior Word List 2024 with hyphens and spaces.json": 305,
	"./SpellBowl/Grade10/2024/premium300/Senior Word List 2024 with hyphens.json": 306,
	"./SpellBowl/Grade10/2024/premium300/Senior Word List 2024 with spaces.json": 307,
	"./SpellBowl/Grade10/2024/premium300/Senior Word List 2024 with upper cases.json": 308,
	"./SpellBowl/Grade10/2024/premium300/Senior Word List 2024.json": 309,
	"./SpellBowl/Grade10/2025/premium0/Senior Word List 2025.json": 310,
	"./SpellBowl/Grade10/2025/premium0/Senior Word List 2025.json with hyphens and spaces.json": 311,
	"./SpellBowl/Grade10/2025/premium0/Senior Word List 2025.json with upper cases.json": 312,
	"./SpellBowl/Grade10/2025/premium0/Senior Word List 2025_filtered.json": 313,
	"./SpellBowl/Grade11/2023/premium300/Senior Word List 2023.json": 314,
	"./SpellBowl/Grade11/2024/premium300/AI Generated Complex Senior Word List 2024.json": 315,
	"./SpellBowl/Grade11/2024/premium300/Senior Word List 2024 with hyphens and spaces.json": 316,
	"./SpellBowl/Grade11/2024/premium300/Senior Word List 2024 with hyphens.json": 317,
	"./SpellBowl/Grade11/2024/premium300/Senior Word List 2024 with spaces.json": 318,
	"./SpellBowl/Grade11/2024/premium300/Senior Word List 2024 with upper cases.json": 319,
	"./SpellBowl/Grade11/2024/premium300/Senior Word List 2024.json": 320,
	"./SpellBowl/Grade11/2025/premium0/Senior Word List 2025.json": 321,
	"./SpellBowl/Grade11/2025/premium0/Senior Word List 2025.json with hyphens and spaces.json": 322,
	"./SpellBowl/Grade11/2025/premium0/Senior Word List 2025.json with upper cases.json": 323,
	"./SpellBowl/Grade11/2025/premium0/Senior Word List 2025_filtered.json": 324,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl0.json": 325,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl01.json": 326,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl100.json": 327,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl150.json": 328,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl200.json": 329,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl250.json": 330,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl300.json": 331,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl350.json": 332,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl400.json": 333,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl450.json": 334,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl50.json": 335,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl500.json": 336,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl550.json": 337,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl600.json": 338,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl650.json": 339,
	"./SpellBowl/Grade12/2021/premium300/SpellBowl700.json": 340,
	"./SpellBowl/Grade12/2022/premium300/Spell_Bowl_Elementary_2022_with_meanings.json": 341,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_100.json": 342,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_150.json": 343,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_200.json": 344,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_250.json": 345,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_300.json": 346,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_350.json": 347,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_400.json": 348,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_450.json": 349,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_50.json": 350,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_500.json": 351,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_550.json": 352,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_600.json": 353,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_650.json": 354,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_700.json": 355,
	"./SpellBowl/Grade12/2022/premium300/spellbowlelementary_2022_750.json": 356,
	"./SpellBowl/Grade12/2023/premium300/Senior Word List 2023.json": 357,
	"./SpellBowl/Grade12/2024/premium300/AI Generated Complex Senior Word List 2024.json": 358,
	"./SpellBowl/Grade12/2024/premium300/Senior Word List 2024 with hyphens and spaces.json": 359,
	"./SpellBowl/Grade12/2024/premium300/Senior Word List 2024 with hyphens.json": 360,
	"./SpellBowl/Grade12/2024/premium300/Senior Word List 2024 with spaces.json": 361,
	"./SpellBowl/Grade12/2024/premium300/Senior Word List 2024 with upper cases.json": 362,
	"./SpellBowl/Grade12/2024/premium300/Senior Word List 2024.json": 363,
	"./SpellBowl/Grade12/2025/premium0/Senior Word List 2025.json": 364,
	"./SpellBowl/Grade12/2025/premium0/Senior Word List 2025.json with hyphens and spaces.json": 365,
	"./SpellBowl/Grade12/2025/premium0/Senior Word List 2025.json with upper cases.json": 366,
	"./SpellBowl/Grade12/2025/premium0/Senior Word List 2025_filtered.json": 367,
	"./SpellBowl/Grade4/2023/premium300/Elementary Word List 2023.json": 368,
	"./SpellBowl/Grade4/2024/premium300/AI Generated Complex Elementary Word List 2024.json": 369,
	"./SpellBowl/Grade4/2024/premium300/Elementary Word List 2024 with hyphens and spaces.json": 370,
	"./SpellBowl/Grade4/2024/premium300/Elementary Word List 2024 with hyphens.json": 371,
	"./SpellBowl/Grade4/2024/premium300/Elementary Word List 2024 with spaces.json": 372,
	"./SpellBowl/Grade4/2024/premium300/Elementary Word List 2024 with upper cases.json": 373,
	"./SpellBowl/Grade4/2024/premium300/Elementary Word List 2024.json": 374,
	"./SpellBowl/Grade4/2025/premium0/Elementary Word List 2025.json": 375,
	"./SpellBowl/Grade4/2025/premium0/Elementary Word List 2025.json with hyphens and spaces.json": 376,
	"./SpellBowl/Grade4/2025/premium0/Elementary Word List 2025.json with upper cases.json": 377,
	"./SpellBowl/Grade4/2025/premium0/Elementary Word List 2025_filtered.json": 378,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl0.json": 379,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl01.json": 380,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl100.json": 381,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl150.json": 382,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl200.json": 383,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl250.json": 384,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl300.json": 385,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl350.json": 386,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl400.json": 387,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl450.json": 388,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl50.json": 389,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl500.json": 390,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl550.json": 391,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl600.json": 392,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl650.json": 393,
	"./SpellBowl/Grade5/2021/premium300/SpellBowl700.json": 394,
	"./SpellBowl/Grade5/2022/premium300/Spell_Bowl_Elementary_2022_with_meanings.json": 395,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_100.json": 396,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_150.json": 397,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_200.json": 398,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_250.json": 399,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_300.json": 400,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_350.json": 401,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_400.json": 402,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_450.json": 403,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_50.json": 404,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_500.json": 405,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_550.json": 406,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_600.json": 407,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_650.json": 408,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_700.json": 409,
	"./SpellBowl/Grade5/2022/premium300/spellbowlelementary_2022_750.json": 410,
	"./SpellBowl/Grade5/2023/premium300/Elementary Word List 2023.json": 411,
	"./SpellBowl/Grade5/2024/premium500/AI Generated Complex Elementary Word List 2024.json": 412,
	"./SpellBowl/Grade5/2024/premium500/Elementary Word List 2024 with hyphens and spaces.json": 413,
	"./SpellBowl/Grade5/2024/premium500/Elementary Word List 2024 with hyphens.json": 414,
	"./SpellBowl/Grade5/2024/premium500/Elementary Word List 2024 with spaces.json": 415,
	"./SpellBowl/Grade5/2024/premium500/Elementary Word List 2024 with upper cases.json": 416,
	"./SpellBowl/Grade5/2024/premium500/Elementary Word List 2024.json": 417,
	"./SpellBowl/Grade5/2025/premium0/Elementary Word List 2025 with hyphens and spaces.json": 418,
	"./SpellBowl/Grade5/2025/premium0/Elementary Word List 2025.json": 419,
	"./SpellBowl/Grade5/2025/premium0/Elementary Word List 2025.json with upper cases.json": 420,
	"./SpellBowl/Grade5/2025/premium0/Elementary Word List 2025_filtered.json": 421,
	"./SpellBowl/Grade6/2022/premium300/CommonlyMissedJunior.json": 422,
	"./SpellBowl/Grade6/2022/premium300/Spell_Bowl_Junior_2022_with_meanings.json": 423,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_100.json": 424,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1000.json": 425,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1050.json": 426,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1100.json": 427,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1150.json": 428,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1200.json": 429,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1250.json": 430,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1300.json": 431,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1350.json": 432,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_1400.json": 433,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_150.json": 434,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_200.json": 435,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_250.json": 436,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_300.json": 437,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_350.json": 438,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_400.json": 439,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_450.json": 440,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_50.json": 441,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_500.json": 442,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_550.json": 443,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_600.json": 444,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_650.json": 445,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_700.json": 446,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_750.json": 447,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_800.json": 448,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_850.json": 449,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_900.json": 450,
	"./SpellBowl/Grade6/2022/premium300/spellbowljunior_2022_950.json": 451,
	"./SpellBowl/Grade6/2023/premium300/Junior Word List 2023.json": 452,
	"./SpellBowl/Grade6/2024/premium300/AI Generated Complex Junior Word List 2024.json": 453,
	"./SpellBowl/Grade6/2024/premium300/Junior Word List 2024 with hyphens and spaces.json": 454,
	"./SpellBowl/Grade6/2024/premium300/Junior Word List 2024 with hyphens.json": 455,
	"./SpellBowl/Grade6/2024/premium300/Junior Word List 2024 with spaces.json": 456,
	"./SpellBowl/Grade6/2024/premium300/Junior Word List 2024 with upper cases.json": 457,
	"./SpellBowl/Grade6/2024/premium300/Junior Word List 2024.json": 458,
	"./SpellBowl/Grade6/2025/premium0/Junior Word List 2025.json": 459,
	"./SpellBowl/Grade6/2025/premium0/Junior Word List 2025.json with hyphens and spaces.json": 460,
	"./SpellBowl/Grade6/2025/premium0/Junior Word List 2025.json with upper cases.json": 461,
	"./SpellBowl/Grade6/2025/premium0/Junior Word List 2025_filtered.json": 462,
	"./SpellBowl/Grade7/2023/premium200/Junior Word List 2023.json": 463,
	"./SpellBowl/Grade7/2023/premium300/Junior Word List 2023_both.json": 464,
	"./SpellBowl/Grade7/2023/premium300/Junior Word List 2023_hyphen.json": 465,
	"./SpellBowl/Grade7/2023/premium300/Junior Word List 2023_space.json": 466,
	"./SpellBowl/Grade7/2024/premium200/AI Generated Complex Junior Word List 2024.json": 467,
	"./SpellBowl/Grade7/2024/premium200/Junior Word List 2024 with hyphens and spaces.json": 468,
	"./SpellBowl/Grade7/2024/premium200/Junior Word List 2024 with hyphens.json": 469,
	"./SpellBowl/Grade7/2024/premium200/Junior Word List 2024 with spaces.json": 470,
	"./SpellBowl/Grade7/2024/premium200/Junior Word List 2024 with upper cases.json": 471,
	"./SpellBowl/Grade7/2024/premium200/Junior Word List 2024.json": 472,
	"./SpellBowl/Grade7/2025/premium0/Junior Word List 2025.json": 473,
	"./SpellBowl/Grade7/2025/premium0/Junior Word List 2025.json with hyphens and spaces.json": 474,
	"./SpellBowl/Grade7/2025/premium0/Junior Word List 2025.json with upper cases.json": 475,
	"./SpellBowl/Grade7/2025/premium0/Junior Word List 2025_filtered.json": 476,
	"./SpellBowl/Grade8/2023/premium300/Junior Word List 2023.json": 477,
	"./SpellBowl/Grade8/2024/premium300/AI Generated Complex Junior Word List 2024.json": 478,
	"./SpellBowl/Grade8/2024/premium300/Junior Word List 2024 with hyphens and spaces.json": 479,
	"./SpellBowl/Grade8/2024/premium300/Junior Word List 2024 with hyphens.json": 480,
	"./SpellBowl/Grade8/2024/premium300/Junior Word List 2024 with spaces.json": 481,
	"./SpellBowl/Grade8/2024/premium300/Junior Word List 2024 with upper cases.json": 482,
	"./SpellBowl/Grade8/2024/premium300/Junior Word List 2024.json": 483,
	"./SpellBowl/Grade8/2025/premium0/Junior Word List 2025.json": 484,
	"./SpellBowl/Grade8/2025/premium0/Junior Word List 2025.json with hyphens and spaces.json": 485,
	"./SpellBowl/Grade8/2025/premium0/Junior Word List 2025.json with upper cases.json": 486,
	"./SpellBowl/Grade8/2025/premium0/Junior Word List 2025_filtered.json": 487,
	"./SpellBowl/Grade9/2022/premium300/Spell_Bowl_Senior_2022_with_meanings.json": 488,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_100.json": 489,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1000.json": 490,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1050.json": 491,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1100.json": 492,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1150.json": 493,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1200.json": 494,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1250.json": 495,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1300.json": 496,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1350.json": 497,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1400.json": 498,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1450.json": 499,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_150.json": 500,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1500.json": 501,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1550.json": 502,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1600.json": 503,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1650.json": 504,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1700.json": 505,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1750.json": 506,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1800.json": 507,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1850.json": 508,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1900.json": 509,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_1950.json": 510,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_200.json": 511,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_2000.json": 512,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_2050.json": 513,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_2100.json": 514,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_2150.json": 515,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_2200.json": 516,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_250.json": 517,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_300.json": 518,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_350.json": 519,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_400.json": 520,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_450.json": 521,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_50.json": 522,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_500.json": 523,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_550.json": 524,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_600.json": 525,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_650.json": 526,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_700.json": 527,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_750.json": 528,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_800.json": 529,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_850.json": 530,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_900.json": 531,
	"./SpellBowl/Grade9/2022/premium300/spellbowlsenior_2022_950.json": 532,
	"./SpellBowl/Grade9/2023/premium300/Senior Word List 2023.json": 533,
	"./SpellBowl/Grade9/2024/premium300/AI Generated Complex Senior Word List 2024.json": 534,
	"./SpellBowl/Grade9/2024/premium300/Senior Word List 2024 with hyphens and spaces.json": 535,
	"./SpellBowl/Grade9/2024/premium300/Senior Word List 2024 with hyphens.json": 536,
	"./SpellBowl/Grade9/2024/premium300/Senior Word List 2024 with spaces.json": 537,
	"./SpellBowl/Grade9/2024/premium300/Senior Word List 2024 with upper cases.json": 538,
	"./SpellBowl/Grade9/2024/premium300/Senior Word List 2024.json": 539,
	"./SpellBowl/Grade9/2025/premium0/Senior Word List 2025 with hyphens and spaces.json": 540,
	"./SpellBowl/Grade9/2025/premium0/Senior Word List 2025 with upper cases.json": 541,
	"./SpellBowl/Grade9/2025/premium0/Senior Word List 2025.json": 542,
	"./SpellBowl/Grade9/2025/premium0/Senior Word List 2025_filtered.json": 543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 222;